import { render, staticRenderFns } from "./SuccessSnackBar.vue?vue&type=template&id=45f6a36a"
import script from "./SuccessSnackBar.vue?vue&type=script&lang=js"
export * from "./SuccessSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports